module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"search":"Search","stores":"Stores","help":"Help","previewMode":"Preview Mode"},"de":{"search":"Suche","stores":"Filiale","help":"Hilfe","previewMode":"????"}}')
  delete Component.options._Ctor
}
